/**
 * This enum must contain the same fields like `UserRole` from db-entities
 */
export enum UserRole {
  EMPLOYEE = 0,
  MANAGER = 1,
  ADMINISTRATOR = 2,
}
